/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { SafetyAction } from "./SafetyAction";
import type { SafetyRuleOperator } from "./SafetyRuleOperator";

export interface SafetyRule {
  question_id: string;
  operator: SafetyRuleOperator;
  value: number;
  action: SafetyAction;
}
